import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LanguageEntity} from './language.entity';
import {SystemEntity} from './system.entity';

@EntityTable('language_system_xref', '25758132-56a3-45d5-810f-b0734b77a340')
export class LanguageSystemXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LanguageEntity, false, false, FieldRelationKind.BELONGS_TO, 'language', 'aliasId', 'languageId')
    public languageId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.BOOLEAN)
    public primary: boolean;

    @Transient()
    public language: LanguageEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;
}
